import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { ClarityModule } from '@clr/angular';
import { LandingModule } from '@modules/landing/landing.module';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { NotificationModule } from '@progress/kendo-angular-notification';
import { NavbarComponent } from '@shared/components/navbar/navbar.component';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ApiService } from './core/services/api.service';
import { AlertService } from './core/services/alert.service';

import 'hammerjs';
import { NavService } from './modules/navigation-menu/nav.service';
import { SavedModalService } from './core/services/saved-modal.service';
import { ChartsModule } from '@progress/kendo-angular-charts';
import { EsriAuthService } from './core/services/esri-auth.service';
import { UnauthorizedComponent } from './shared/components/unauthorized/unauthorized.component';
import { LoadingComponent } from './shared/components/loading/loading.component';
import { TokenInterceptor } from './core/interceptors/TokenInterceptor';
import { ErrorHandlerInterceptor } from './core/interceptors/ErrorHandler';
import { MarkdownModule } from 'ngx-markdown';
import { FacilityTypesHelpers } from './core/services/FacilityTypesHelper';
import { MessageDialogService } from './shared/components/message-dialog/message-dialog.service';
import { MessageDialogComponent } from './shared/components/message-dialog/message-dialog.component';
@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    UnauthorizedComponent,
    LoadingComponent,
    MessageDialogComponent,
  ],
  imports: [
    RouterModule,
    BrowserModule,
    ClarityModule,
    HttpClientModule,
    AppRoutingModule,
    LandingModule,
    DropDownsModule,
    NotificationModule,
    BrowserAnimationsModule,
    ChartsModule,
    MarkdownModule.forRoot(),
  ],
  providers: [
    { provide: LocationStrategy, useClass: PathLocationStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorHandlerInterceptor,
      multi: true,
    },
    AlertService,
    ApiService,
    FacilityTypesHelpers,
    NavService,
    SavedModalService,
    EsriAuthService,
    MessageDialogService,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent],
  exports: [],
})
export class AppModule {}
